/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { SubcontractorChangeOrderRequestsControllerFindAllQueryResponse, SubcontractorChangeOrderRequestsControllerFindAllPathParams, SubcontractorChangeOrderRequestsControllerFindAllQueryParams, SubcontractorChangeOrderRequestsControllerFindAll401, SubcontractorChangeOrderRequestsControllerFindAll403 } from "../../models/changeOrdersController/SubcontractorChangeOrderRequestsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { subcontractorChangeOrderRequestsControllerFindAll } from "../../clients/change-ordersService/subcontractorChangeOrderRequestsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const subcontractorChangeOrderRequestsControllerFindAllQueryKey = (id: SubcontractorChangeOrderRequestsControllerFindAllPathParams["id"], params: SubcontractorChangeOrderRequestsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/potential-change-orders/:id/subcontractor-change-order-requests',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type SubcontractorChangeOrderRequestsControllerFindAllQueryKey = ReturnType<typeof subcontractorChangeOrderRequestsControllerFindAllQueryKey>;
export function subcontractorChangeOrderRequestsControllerFindAllQueryOptions(id: SubcontractorChangeOrderRequestsControllerFindAllPathParams["id"], params?: SubcontractorChangeOrderRequestsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = subcontractorChangeOrderRequestsControllerFindAllQueryKey(id, params);
  return queryOptions<SubcontractorChangeOrderRequestsControllerFindAllQueryResponse, ResponseErrorConfig<SubcontractorChangeOrderRequestsControllerFindAll401 | SubcontractorChangeOrderRequestsControllerFindAll403>, SubcontractorChangeOrderRequestsControllerFindAllQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return subcontractorChangeOrderRequestsControllerFindAll(id, params, config);
    }
  });
}

/**
 * @summary List subcontractor change order requests
 * {@link /api/v1/potential-change-orders/:id/subcontractor-change-order-requests}
 */
export function useSubcontractorChangeOrderRequestsControllerFindAll<TData = SubcontractorChangeOrderRequestsControllerFindAllQueryResponse, TQueryData = SubcontractorChangeOrderRequestsControllerFindAllQueryResponse, TQueryKey extends QueryKey = SubcontractorChangeOrderRequestsControllerFindAllQueryKey>(id: SubcontractorChangeOrderRequestsControllerFindAllPathParams["id"], params?: SubcontractorChangeOrderRequestsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<SubcontractorChangeOrderRequestsControllerFindAllQueryResponse, ResponseErrorConfig<SubcontractorChangeOrderRequestsControllerFindAll401 | SubcontractorChangeOrderRequestsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? subcontractorChangeOrderRequestsControllerFindAllQueryKey(id, params);
  const query = useQuery({
    ...subcontractorChangeOrderRequestsControllerFindAllQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SubcontractorChangeOrderRequestsControllerFindAll401 | SubcontractorChangeOrderRequestsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}